import { compact, isEmpty } from 'lodash-es';
import type { FC } from 'react';

import { TextButton } from '@xing-com/button';
import { Container, Section } from '@xing-com/layout-primitives';

import { useCtaLinkOnClick } from '../cta-link';
import { PageSection } from '../page-section';
import type { PageSectionProps } from '../page-section/page-section';
import { ShowMore } from '../show-more';

import { TagsList } from './list';

export interface IProps extends PageSectionProps {
  ctaTrackingParamWithoutPrefix: string;
  ctaTranslationKey: string;
  getTagHref?: (tag: string) => string | undefined;
  headline?: string;
  highlightedTags?: Array<string>;
  scrambledProfileUrl: string | null;
  tagDataQa?: string;
  tags: Array<string>;
}

export const TagsListPageSection: FC<IProps> = ({
  ctaTrackingParamWithoutPrefix,
  ctaTranslationKey,
  dataQa,
  getTagHref,
  headlineTranslationKey,
  highlightedTags,
  scrambledProfileUrl,
  scrollTrackingId,
  tagDataQa,
  tags,
}) => {
  const onCtaButtonClick = useCtaLinkOnClick({
    scrambledProfileUrl,
    trackingParamWithoutPrefix: ctaTrackingParamWithoutPrefix,
  });

  if (isEmpty(compact(tags)) && isEmpty(compact(highlightedTags))) {
    return null;
  }

  const pageSectionAfterHeadline = (
    <TextButton onClick={onCtaButtonClick}>
      <ShowMore translationKey={ctaTranslationKey} />
    </TextButton>
  );

  return (
    <PageSection
      afterHeadline={pageSectionAfterHeadline}
      dataQa={dataQa}
      headlineTranslationKey={headlineTranslationKey}
      scrollTrackingId={scrollTrackingId}
    >
      <Section noBlockPadding>
        <Container>
          {highlightedTags && (
            <TagsList
              getTagHref={getTagHref}
              highlighted
              tagDataQa={`${tagDataQa}-highlighted`}
              tags={highlightedTags}
            />
          )}
          {tags && (
            <TagsList
              getTagHref={getTagHref}
              tagDataQa={tagDataQa}
              tags={tags}
            />
          )}
        </Container>
      </Section>
    </PageSection>
  );
};
